<template>
  <div>
    <title-bar title="用户编辑">
      <el-button type="primary" @click="save()" :loading="loading">保存</el-button>
      <el-button type="default" @click="cancel()">取消</el-button>
    </title-bar>
    <div class="page-body">
      <el-form ref="editForm" :model="user" label-width="80px" :rules="validateRules"
               style="width: 800px;margin:auto">
        <el-form-item label="姓名" prop="userName">
          <el-input v-model="user.userName" clearable placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="帐号" prop="loginName">
          <el-input v-model="user.loginName" clearable placeholder="请输入帐号"></el-input>
        </el-form-item>
        <el-form-item label="所属单位" prop="compId">
          <comp-select v-model="user.compId"></comp-select>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="user.mobile" clearable placeholder="请输入手机号" :max-length="11"></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="valid">
          <el-switch v-model="user.valid"></el-switch>
        </el-form-item>
      </el-form>
      <div class="button-container">
        <el-button type="primary" @click="save()" :loading="loading">保存</el-button>
        <el-button type="default" @click="cancel()">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
import CodeSelect from "@/components/base/CodeSelect";
import CompSelect from "@/components/base/CompSelect";
export default {
  name: 'UserEdit',
  components: {CompSelect, CodeSelect, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      editing: false,
      user: {
        compName: '',
        compType: '',
        compLevel: '',
        stopDay: null,
        valid: true
      },
      records: [],
      validateRules: {
        userName: [{required:true, message:'姓名不能为空', trigger: 'blur'}],
        loginName: [{required:true, message:'登录帐号不能为空', trigger: 'change'}],
        compId: [{required:true, message:'单位不能为空', trigger: 'change'}]
      }
    }
  },
  created() {
    let userId = this.$route.query.userId;
    if(userId) {
      this.loading = true;
      this.postForm("/user/getById?userId="+userId,null,true).then(dr=>{
        this.user = dr.bean;
      }).finally(()=>{
        this.loading = false;
      });
    }
  },
  methods: {
    save(){
      this.$refs.editForm.validate((yes)=>{
        if(yes){
          this.loading = true;
          this.postForm("/user/saveUser", this.user, true).then(dr => {
            this.$router.back();
          }).finally(()=>{
            this.loading = false;
          });
        }
      });
    },
    cancel(){
      this.$router.back();
    }
  }
}
</script>

<style scoped>

</style>